import {
  LOAD_CART,
  ADD_CART,
  REMOVE_CART,
  DEC_CART,
  INC_CART,
  UPDATE_CART_QUANTITY,
  EMPTY_CART
} from "../actions/cart";

const initialState = {
  items: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EMPTY_CART:
      localStorage.removeItem("cart");
      return {
        ...state,
        items: []
      };
    case LOAD_CART:
      return {
        ...state,
        items: action.payload
      };
    case ADD_CART:
      const quantity = parseInt(action.payload.quantity) || 1;
      const itemIndex = state.items.findIndex(({ id }) => id === action.payload.product.id);
      let newItems;

      if (itemIndex !== -1) {
        // Update existing item - create new array with new item object
        newItems = state.items.map((item, index) => {
          if (index === itemIndex) {
            return {
              ...item,
              quantity: parseInt(item.quantity || 0) + quantity
            };
          }
          return item;
        });
      } else {
        // Add new item
        const newProduct = {
          ...action.payload.product,
          quantity: quantity
        };
        newItems = [...state.items, newProduct];
      }

      localStorage.setItem("cart", JSON.stringify(newItems));
      return {
        ...state,
        items: newItems
      };

    case REMOVE_CART:
      const removeItems = state.items.filter(
        item => item.id !== action.payload
      );
      localStorage.setItem("cart", JSON.stringify(removeItems));
      return {
        ...state,
        items: removeItems
      };

    case INC_CART:
      const incItems = state.items.map(item => {
        if (item.id === action.payload) {
          return {
            ...item,
            quantity: parseInt(item.quantity || 0) + 1
          };
        }
        return item;
      });

      localStorage.setItem("cart", JSON.stringify(incItems));
      return {
        ...state,
        items: incItems
      };

    case DEC_CART:
      const decItems = state.items.map(item => {
        if (item.id === action.payload) {
          return {
            ...item,
            quantity: Math.max(1, parseInt(item.quantity || 1) - 1)
          };
        }
        return item;
      });
      localStorage.setItem("cart", JSON.stringify(decItems));
      return {
        ...state,
        items: decItems
      };

    case UPDATE_CART_QUANTITY:
      const updateItems = state.items.map(item => {
        if (item.id === action.payload.id) {
          return {
            ...item,
            quantity: Math.max(1, parseInt(action.payload.quantity) || 1)
          };
        }
        return item;
      });
      localStorage.setItem("cart", JSON.stringify(updateItems));
      return {
        ...state,
        items: updateItems
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/cartReducer.js